/**
 * Shared axios instance.
 *
 * By default, GET responses are allowed to be cached by the browser for better
 * public-page performance. Cache-busting (timestamp param + no-cache headers)
 * is applied ONLY to endpoints that must always return fresh data:
 *   - latest draw results        (".../draws")
 *   - prediction comparison      ("comparison")
 *   - pipeline monitor / queue   ("/pipeline")
 *   - admin pages & admin reads  ("/admin")
 */
import axios from 'axios';

const api = axios.create();

// URL fragments whose GET responses must never be served from cache.
const ALWAYS_FRESH = ['/admin', '/pipeline', '/draws', 'comparison'];

// Add cache-busting ONLY for freshness-critical GET requests.
api.interceptors.request.use((config) => {
  if (config.method === 'get') {
    const url = config.url || '';
    const needsFresh = ALWAYS_FRESH.some((fragment) => url.includes(fragment));
    if (needsFresh) {
      config.params = {
        ...config.params,
        _t: Date.now()
      };
      config.headers = config.headers || {};
      config.headers['Cache-Control'] = 'no-cache, no-store, must-revalidate';
      config.headers['Pragma'] = 'no-cache';
      config.headers['Expires'] = '0';
    }
  }
  return config;
});

export default api;
